import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Icon } from 'antd';
const styles = {
  modalClass: {
    '& .ant-modal-body': {
      padding: '24px 0px 0px 0px',
      borderRadius: '5px',
    },
  },
  rowClass: {
    marginBottom: '15px',
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'space-around',
  },
};
class Protip extends React.PureComponent<any, any> {
  render() {
    const { classes, onOkay, height } = this.props;
    return <Modal
      closable={true}
      className={classes.modalClass}
      width={400}
      zIndex={3000}
      onCancel={onOkay}
      visible={this.props.visible}
      footer={null}>
      <div style={{
        height: height || 250, display: 'flex', flexDirection: 'column',
        alignContent: 'space-between', padding: '0px 24px 24px 24px',
      }}>
        <div className={classes.rowClass}>
          <Icon type="check-circle" theme="filled"
            style={{ color: '#52C41A', fontSize: '50px' }} />
        </div>
        <div className={classes.rowClass}>
          <h2>{this.props.success}</h2>
        </div>
        <div className={classes.rowClass}>
          {this.props.message1}
        </div>
        <div className={classes.rowClass}>
          <i style={{ fontSize: '11px' }}>
            {this.props.message2}</i>
        </div>
        <div className={classes.rowClass} style={{ fontSize: '17px' }}>
          <a onClick={onOkay}>{this.props.okay}</a>
        </div>
      </div>
    </Modal>;
  }
}

export default injectSheet(styles)(Protip);
